module.exports = __webpack_public_path__ + "img/adobe-after-effects.0d195dbd.png";